<template>
    <div>
        <PCExample 
            v-if=" exampleList != '' && isMobile === false" 
            :exampleList="exampleList" 
            :infor="infor" 
        />

        <MobExample 
            v-else-if=" exampleList != '' && isMobile" 
            :exampleList="exampleList" 
            :infor="infor" 
        />
    </div>
</template>

<script>

    import PCExample from '@/components/pc/PCExample'
    import MobExample from '@/components/mobile/MobExample'

    // import jquery from 'jquery'

    import exampleJson from '@/json/the-example-example-list.js'


    export default {
        name: 'Example',
        props: {
            isMobile: Boolean
        },
        components: {
            MobExample,
            PCExample
        },
        data: function(){
            return {
                infor: {
                    title: '案例'
                },
                exampleList: exampleJson.list
            }
        },    
        mounted() {
            // let _this = this;
            // window.getAjaxJson = '';
            // jquery.get('./json/the-example-example-list.js', function(){
            //    _this.exampleList =  window.getAjaxJson.list;
            // });
        }

    }

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>